<script setup lang="ts">
import { ref, watch } from 'vue'
import { router } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  userId: { type: String, required: true },
  currentImage: { type: String, default: null },
  label: { type: String, default: '' },
})

const file = ref<File>()
const saving = ref(false)
const previewUrl = ref(props.currentImage)

watch(
  () => props.currentImage,
  (newVal) => {
    previewUrl.value = newVal
  },
)

function upload() {
  if (!file.value) return

  saving.value = true

  const form = new FormData()
  form.append('profile_image', file.value)

  router.post(`/users/${props.userId}/profile-image`, form, {
    forceFormData: true,
    onSuccess: () => {
      // Refresh preview, bust cache
      previewUrl.value = `/users/${props.userId}/profile-image/raw?ts=${Date.now()}`
      file.value = undefined
    },
    onFinish: () => {
      saving.value = false
    },
  })
}
</script>

<template>
  <div class="flex w-full items-center gap-4">
    <!-- Upload field left -->
    <div class="flex-1">
      <InertiaFormField :label="label">
        <FileUploadField v-model="file" :preview-url="previewUrl" />
      </InertiaFormField>
    </div>

    <!-- Button right -->
    <div class="flex items-center">
      <Button
        :label="t('actions.upload')"
        icon="pi pi-upload"
        :loading="saving"
        :disabled="!file"
        :severity="!file ? 'secondary' : 'primary'"
        class="whitespace-nowrap"
        @click="upload" />
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "actions": {
      "upload": "Upload Profile Picture"
    }
  },
  "de": {
    "actions": {
      "upload": "Profilbild hochladen"
    }
  }
}
</i18n>
